import { apiClient } from './apiClient';

export type HangfireDashboard = {
  dashboardUrl: string;
};

export async function fetchHangfireDashboardUrl(): Promise<HangfireDashboard> {
  const response = await apiClient.get<HangfireDashboard>('/v1/monitor/hangfire-dashboard');
  return response.data;
}
